module.exports = __webpack_public_path__ + "media/images/spinner-d9959854b184a252614da27682fa9562.svg";